import { Input } from 'antd'
import React, { useState, useEffect } from 'react'
// import "./styles/acl.css"
import { ReactComponent as UnCheckedIcon } from "../../../../../assets/svg/checkbox.svg"
import { ReactComponent as CheckedIcon } from '../../../../../assets/svg/uncheckbox.svg'
import { ReactComponent as DeleteIcon } from '../../../../../assets/svg/delete.svg'
import { Http } from '../../../../../helpers/axois'
import { useSelector } from 'react-redux'
import { Modal } from '../../../../../helpers/commonUi'

const AclEventNodeDrawer = ((props: any) => {
    const {setAclProperties,eventProperty }:any = props;
    const {componentAcl = {}} =  eventProperty
    const tabList = ["Configuration", "Data"]
    const [selectedTab, setSelectedTab] = useState<string>("Configuration")
    const [filterValue, setFilterValue] = useState<any>("")
    const [crossAppValue, setCrossAppValue] = useState<any>("")
    const { onClose } = props;
    const [data, setData] = useState<any>({})
    const [localComponentAcl,setLocalComponentAcl] = useState<any>(componentAcl)
    const [crossAppAcl,setCrossAppAcl] = useState<any>({})
    useEffect(() => {
        if (selectedTab === "Configuration") {
            getConfiguration()
        } else if (selectedTab === "Data") {
            getData()
        }
        setFilterValue("")
        setCrossAppValue("")
    }, [selectedTab])
    const { appVersion, appBranch, selectedApp } = useSelector((state: any) => state.apps)

    const getConfiguration = () => {
        const appId = selectedApp.id
        const version = appVersion && appVersion[appId].versionId;
        const currentBranchId = appBranch && appBranch[appId] && appBranch[appId].branchId
        Http.get(`/app/${appId}/config?versionId=${version}&branchId=${currentBranchId}`).subscribe((configRes: any) => {
            setData({
                ...data,
                configList: configRes.map((o: any) => { return { ...o, key_: o.key, visible: false } })
            })
        });
    }

    const getData = () => {
        const appId = selectedApp.id
        const version = appVersion && appVersion[appId].versionId;
        Http.get(`/app/${appId}/collections?versionId=${version}`).subscribe((dataRes: any) => {
            if (localComponentAcl && localComponentAcl.a8data) {
                let crossAppData:any = {}
                let a8data = {};
                Object.keys(localComponentAcl.a8data).forEach((coll:string)=>{
                    dataRes.forEach((val:any)=>{
                        if (val.coll_name !== coll) {
                            crossAppData = {...crossAppData, [coll]: localComponentAcl.a8data[coll]}
                        } else {
                            a8data = {...a8data , [coll]: localComponentAcl.a8data[coll]}
                        }
                    })
                })
                setCrossAppAcl(crossAppData)
                setLocalComponentAcl({...localComponentAcl,a8data})
            }
            setData({
                ...data,
                dataList: dataRes
            })
        });
    }

    const onChange = (key:string,id:any,type?:any) =>{
        if (key==="config"){
            let a8config = (localComponentAcl && localComponentAcl.a8config) ? localComponentAcl.a8config : {}
            if (localComponentAcl && localComponentAcl.a8config && localComponentAcl.a8config[id]){
                delete a8config[id]
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8config
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8config:{
                        ...a8config,
                        [id] : 2
                    }
                })
            }
        }  else if (key === "data") {
            let a8data = (localComponentAcl && localComponentAcl.a8data) ? localComponentAcl.a8data : {}
            let permissions : any = getPermissions(a8data[id])
            const permissionNo = [32,16,8,4,2];
            const permissionName = ["execute","delete","create","update","read"]
            let val = a8data[id] ? a8data[id] : 0;
            let index = permissionName.findIndex((name)=> name === type)
            if (permissions[type]) {
                val = val - permissionNo[index];
            } else {
                val = val + permissionNo[index];
            }
            if (val === 0) {
                delete a8data[id];
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8data:{
                        ...a8data,
                    }
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8data:{
                        ...a8data,
                        [id] : val
                    }
                })
            }
        } else if (key === "crossCollectionData") {
            let a8data =  crossAppAcl ? crossAppAcl : {}
            let permissions : any = getPermissions(a8data[id])
            const permissionNo = [32,16,8,4,2];
            const permissionName = ["execute","delete","create","update","read"]
            let val = a8data[id] ? a8data[id] : 0;
            let index = permissionName.findIndex((name)=> name === type)
            if (permissions[type]) {
                val = val - permissionNo[index];
            } else {
                val = val + permissionNo[index];
            }
            setCrossAppAcl({...a8data,[id] : val})
        }
    }

    const getPermissions = ((value:any)=>{
        const permissionNo = [32,16,8,4,2];
        const permissionName = ["execute","delete","create","update","read"]
        let res = {
            create : false,
            execute: false,
            read: false,
            delete : false,
            update: false
        }
        if (!value){
            return res;
        } else {
            for (let i=0;i<permissionNo.length;i++) {
                if (value - permissionNo[i] >= 0){
                    res = {...res, [permissionName[i]] : true}
                    value = value - permissionNo[i];
                }
            }
        }
        return res;
    })
    const formUpdate = (() => {
        let data: any = {};
        let componentAclData = localComponentAcl ? localComponentAcl : {};
        if (componentAclData || crossAppAcl) {
            let a8Data = componentAclData.a8data ? componentAclData.a8data : {}
            data = { ...data, componentAcl: { ...componentAclData, a8data: { ...a8Data, ...crossAppAcl } } }
        }
        setAclProperties(data.componentAcl)
        onClose();
    })

    const onEnter = (() => {
        if (!crossAppValue.includes(".") || crossAppValue.includes(" ")) {
            return;
        } else {
            setCrossAppAcl({
                ...crossAppAcl,
                [crossAppValue]: 0
            })
            setCrossAppValue("")
        }
    })

    const handleDeleteData = ((key:any)=>{
        let a8data = {...crossAppAcl}
        delete a8data[key]
        setCrossAppAcl({...a8data})
    })
    return (
        <div className='acl_drawer' style={{left:"0px"}}>
            <div style={{ height: "44px", width: "100%", background: "rgba(149, 171, 211, 0.17)", padding: "0px 12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div className='acl_title'>
                    Access Control List
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    <button className='acl_cancel' style={{ outline: 0 }} onClick={(() => { onClose() })}>Cancel</button>
                    <button className='acl_submit' onClick={(()=>{formUpdate()})}>Submit</button>
                </div>
            </div>
            <div className='acl_cont' style={{height:"calc(100% - 50px)"}}>
                <div className='acl_tabs'>
                    {
                        tabList.map((tab: any) => {
                            return <div style={{width:"40%"}} onClick={(() => { setSelectedTab(tab) })} className={`acl_tab ${tab === selectedTab && "active_acl_tab"}`}>{tab}</div>
                        })
                    }
                </div>
                {selectedTab === "Data" ? <div style={{ paddingTop: "11px",paddingBottom:"9px" }}>
                    <label style={{fontSize:"14px",color:"#052f35 "}}>Cross App collection name</label>
                    <Input
                        value={crossAppValue}
                        onChange={((e: any) => {
                            const val = e.target.value
                            setCrossAppValue(val)
                        })}
                        onPressEnter={(()=>{onEnter()})}
                        style={{ background: "#fffff", height: "40px", width: "100%", borderRadius: "4px" }}
                        placeholder={`Cross App collection name`}
                    />
                </div> : null }
                <div style={{ paddingTop: "11px" }}>
                    {selectedTab === "Data" ? <label style={{fontSize:"14px",color:"#052f35 "}}>Permission List</label> : null }
                    <Input
                        value={filterValue}
                        onChange={((e: any) => {
                            const val = e.target.value
                            setFilterValue(val)
                        })}
                        style={{ background: "#fffff", height: "40px", width: "100%", borderRadius: "4px" }}
                        placeholder={`Search ${selectedTab} name...`}
                        suffix={
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.6 16.2C12.7974 16.2 16.2 12.7974 16.2 8.6C16.2 4.40264 12.7974 1 8.6 1C4.40264 1 1 4.40264 1 8.6C1 12.7974 4.40264 16.2 8.6 16.2Z" stroke="#B1B5BD" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17 16.9999L15.4 15.3999" stroke="#B1B5BD" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        }
                    />
                </div>
                {selectedTab === "Configuration" ? <ConfigurationList filterValue={filterValue} componentAcl={(localComponentAcl && localComponentAcl.a8config) ? localComponentAcl.a8config : {}} onChange={onChange} list={data.configList ? data.configList : []} /> : null}
                {selectedTab === "Data" ? <DataList handleDeleteData={handleDeleteData} crossAppAcl={crossAppAcl} setCrossAppAcl={setCrossAppAcl} filterValue={filterValue} getPermissions={getPermissions} componentAcl={(localComponentAcl && localComponentAcl.a8data) ? localComponentAcl.a8data : {}} onChange={onChange} list={data.dataList ? data.dataList : []} /> : null}
            </div>
        </div>
    )
})

const ConfigurationList = ((props: any) => {
    const { list,componentAcl,onChange, filterValue } = props;
    const handleChange = ((key:any)=>{
        if (componentAcl[key]){
            onChange("config",key)
        } else {
            onChange("config",key)
        }
    })
    return (
        <div style={{ paddingTop: "20px",height:"calc(100% - 100px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "50%", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50%", fontSize: "13px", color: "#909BAD", textAlign: "center" }}>READ</h5>
            </div>
            <div>
                {
                    list.filter((val:any)=> val.key.toLowerCase().includes(filterValue.toLowerCase())).map((config: any) => {
                        return (
                            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                                <span className='truncate' style={{ width: "50%", fontSize: "14px", color: "#292D32" }}>{config.key} </span>
                                <div style={{ width: "50%", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                    <span onClick={(()=>{handleChange(config.key)})}>
                                       {componentAcl && componentAcl[config.key] ?  <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
})
const DataList = ((props: any) => {
    const {list,onChange,componentAcl,getPermissions, filterValue,crossAppAcl,handleDeleteData} = props;
    const handleChange = ((key:string,colName:string)=>{
        onChange("data",colName,key)
    })
    const handleCrossAppChange = ((key:string,colName:string)=>{
        onChange("crossCollectionData",colName,key)
    })
    const[deleteModal,setDeleteModal] = useState(false)
    const [deletedData,setDeletedData] = useState("")
    return (
        <div style={{ paddingTop: "20px",height:"calc(100% - 220px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "250px", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>READ</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>CREATE</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>UPDATE</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>DELETE</h5>
            </div>
            <div style={{overflow:"auto",height:"95%"}}>
                {list.filter((val:any)=> val.coll_name.toLowerCase().includes(filterValue.toLowerCase())).map((collection: any) => {
                    let permissions = getPermissions(componentAcl[collection.coll_name])
                    return (
                        <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                            <div style={{ width: "250px" }}  className='truncate' title={collection.coll_name}>
                                <span className='truncate' style={{ fontSize: "14px", color: "#292D32" }}>{collection.coll_name}</span>
                            </div>
                            <div style={{ width: "50px", paddingRight: "10px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleChange("read",collection.coll_name)})}>
                                    {permissions.read ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleChange("create",collection.coll_name)})}>
                                {permissions.create ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleChange("update",collection.coll_name)})}>
                                    {permissions.update ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleChange("delete",collection.coll_name)})}>
                                    {permissions.delete ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                        </div>
                    )
                })}
                {Object.keys(crossAppAcl).length ? <div style={{borderBottom:"1px dashed #B1B5BD",margin:"0px 0px 20px 0px"}}></div> : null }
                {Object.keys(crossAppAcl).filter((val:any)=> val.toLowerCase().includes(filterValue.toLowerCase())).map((collection: any) => {
                    let permissions = getPermissions(crossAppAcl[collection])
                    return (
                        <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                            <div style={{ width: "250px",gap:"10px" }}  className='truncate flex' title={collection}>
                                <div style={{cursor:"pointer"}} onClick={(()=>{setDeleteModal(true);setDeletedData(collection)})}>
                                    <DeleteIcon/>
                                </div>
                                <span className='truncate' style={{ fontSize: "14px", color: "#292D32" }}>{collection}</span>
                            </div>
                            <div style={{ width: "50px", paddingRight: "10px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleCrossAppChange("read",collection)})}>
                                    {permissions.read ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleCrossAppChange("create",collection)})}>
                                {permissions.create ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleCrossAppChange("update",collection)})}>
                                    {permissions.update ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(()=>{handleCrossAppChange("delete",collection)})}>
                                    {permissions.delete ? <CheckedIcon /> : <UnCheckedIcon/>}
                                </span>
                            </div>
                        </div>
                    )
                })}
            </div>
            <Modal
                id="deleteForm"
                dataTestId="delete_form"
                unmountOnCancel={true}
                visible={deleteModal}
                title="DELETE FORM"
                onCancel={() => {
                    setDeleteModal(false)
                    setDeletedData("")
                }}
                // mode='Delete'
                deleteOptions={{
                    type: "Form",
                    validateString: deletedData
                }}
                footer={{
                    enable: true,
                    okText: 'DELETE',
                    cancelText: 'CANCEL',
                    onOk: () => {
                        setDeleteModal(false)
                        handleDeleteData(deletedData)
                        setDeletedData("")
                    }
                }}
            />
        </div>
    )
})
export default AclEventNodeDrawer;